/**
 * @fileoverview gRPC-Web generated client stub for com.kipp.miraibarai.grpc.ops.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.3
// source: miraibaraiops/miraibarai_app_user_api.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as miraibaraiops_miraibarai_app_user_api_pb from '../miraibaraiops/miraibarai_app_user_api_pb'; // proto import: "miraibaraiops/miraibarai_app_user_api.proto"


export class MiraibaraiAppUserAPIClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorAddComment = new grpcWeb.MethodDescriptor(
    '/com.kipp.miraibarai.grpc.ops.v1.MiraibaraiAppUserAPI/AddComment',
    grpcWeb.MethodType.UNARY,
    miraibaraiops_miraibarai_app_user_api_pb.AddCommentRequest,
    miraibaraiops_miraibarai_app_user_api_pb.AddCommentResponse,
    (request: miraibaraiops_miraibarai_app_user_api_pb.AddCommentRequest) => {
      return request.serializeBinary();
    },
    miraibaraiops_miraibarai_app_user_api_pb.AddCommentResponse.deserializeBinary
  );

  addComment(
    request: miraibaraiops_miraibarai_app_user_api_pb.AddCommentRequest,
    metadata?: grpcWeb.Metadata | null): Promise<miraibaraiops_miraibarai_app_user_api_pb.AddCommentResponse>;

  addComment(
    request: miraibaraiops_miraibarai_app_user_api_pb.AddCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: miraibaraiops_miraibarai_app_user_api_pb.AddCommentResponse) => void): grpcWeb.ClientReadableStream<miraibaraiops_miraibarai_app_user_api_pb.AddCommentResponse>;

  addComment(
    request: miraibaraiops_miraibarai_app_user_api_pb.AddCommentRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: miraibaraiops_miraibarai_app_user_api_pb.AddCommentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/com.kipp.miraibarai.grpc.ops.v1.MiraibaraiAppUserAPI/AddComment',
        request,
        metadata || {},
        this.methodDescriptorAddComment,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/com.kipp.miraibarai.grpc.ops.v1.MiraibaraiAppUserAPI/AddComment',
    request,
    metadata || {},
    this.methodDescriptorAddComment);
  }

}

